import _ from 'lodash'
import Channel from "data/websocket/channel"
import * as eventType from "data/socket"
import folderService from "data/folder"
import propertyService from "data/property"
import notificationService from "data/notification"
import socketService from "data/socket"
import { BulkThrottle } from 'data/lib/bulk-throttle'

let fetchProperties // set later to avoid top-level circular dependency

// FolderChannel manages channel connections and events specific to folders
export default class FolderChannel extends Channel {

  handleFolderSelection(folderId) {
    if (!fetchProperties) fetchProperties = BulkThrottle(propertyService.fetchProperties, 1500)
    this.join('folder', folderId.toString());

    this.onEvent(event => {
      switch(event.eventType) {
        case eventType.FOLDER_UPDATED:
          folderService.fetchFolder(folderId)
          break
        case eventType.PROPERTY_CALC_IN_PROGRESS:
          fetchProperties(+event.msg)
          break;
        case eventType.FOLDER_CALC_STARTED_EVENT:
          socketService.newEvent({ eventType: eventType.FOLDER_CALC_STARTED_EVENT, event })
          setTimeout(() => propertyService.fetchByFolderId(folderId, false), 1000)
          //notificationService.notify({ type: "info", message: event.msg, dismiss: 5000 })
          break;

        case eventType.FOLDER_CALC_ERROR_EVENT:
          socketService.newEvent({ eventType: eventType.FOLDER_CALC_ERROR_EVENT, event })
          notificationService.notify({ type: "danger", message: event.msg, dismiss: 5000 })
          break;

        case eventType.FOLDER_CALC_FINISHED_EVENT:
          socketService.newEvent({ eventType: eventType.FOLDER_CALC_FINISHED_EVENT, event })
          //notificationService.notify({ type: "info", message: event.msg, dismiss: 5000 })
          setTimeout(() => propertyService.fetchByFolderId(folderId, false), 1000)
          break;

        case eventType.PROPERTY_CALC_FINISHED:
          fetchProperties(+event.msg)
          break;

        default:
          console.warn('FolderChannel got unknown eventType on:', event)
      }
    })
  }
}
